import { useDbtCloudAccount } from '@/context/DbtCloudProvider';
import { useAccount } from './admin/account';

export const useHasEnterpriseFeatures = () => {
  const { accountId } = useDbtCloudAccount();
  const account = useAccount(accountId || 0);
  const plan = account.data?.plan;
  return plan === 'enterprise' || plan === 'free';
};
